// extracted by mini-css-extract-plugin
export default {"container":"ColumnForm_container__mV9oA","curtain":"ColumnForm_curtain__p152R","submitBtnContainer":"ColumnForm_submitBtnContainer__7k8Ih"};